import React from "react";
import { Customer, CustomerContact } from "../../../../data/entities";
import Section from "./Section";
import { InfoBoxWrapper } from "../Styled";

interface CustomerInfoProps {
    customer?: Customer | null;
    deliveryAddress?: string;
}

interface InfoDef {
    title: string;
    field: string;
    toValue?: (value: any) => string | undefined;
}

const contactFieldToValue = (field: keyof CustomerContact) => (value: any) => {
    // Ensure value is an array before calling find
    if (!Array.isArray(value)) {
        return undefined;
    }
    const defaultContact = value?.find((c: any) => c.contact.is_default)?.contact;
    return defaultContact?.[field];
};

const SECTION_INFOs = [
    {
        title: "Thông tin khách hàng",
        infoDefinitions: [
            { title: "Số điện thoại", field: "phone" },
            { title: "Email", field: "email" },
            { title: "Fax", field: "fax" },
            { title: "Địa chỉ", field: "address" },
        ],
    },
    {
        title: "Thông tin người liên hệ",
        infoDefinitions: [
            { title: "Người liên hệ", field: "contact_list", toValue: contactFieldToValue("name") },
            { title: "Email", field: "contact_list", toValue: contactFieldToValue("email") },
            { title: "Số điện thoại", field: "contact_list", toValue: contactFieldToValue("phone") },
            { title: "Cấp bậc", field: "contact_list", toValue: contactFieldToValue("position") },
        ],
    },
];

const infoListFactory = (customer: any, infoList: InfoDef[]) => {
    if (!customer) return infoList.map(infoDef => ({ title: infoDef.title, value: undefined }));

    return infoList.map((infoDef: InfoDef) => {
        const raw = customer[infoDef.field];
        const value = raw ? (infoDef.toValue ? infoDef.toValue(raw) : raw) : undefined;
        return { title: infoDef.title, value };
    });
};

const getInitials = (name?: string) => {
    if (!name) return "N/A";
    const parts = name.trim().split(/\s+/);
    const initials = parts.length === 1 ? parts[0][0] : (parts[0][0] + parts[parts.length - 1][0]);
    return initials.toUpperCase();
};

const CustomerInfo = ({ customer, deliveryAddress }: CustomerInfoProps) => {

    const Header = ({ title, avatarBg }: { title: string; avatarBg: string }) => (
        <div className="tw-flex tw-items-center tw-gap-3">
            <div
                className={`tw-flex tw-items-center tw-justify-center tw-h-12 tw-w-12 tw-rounded-full ${avatarBg} tw-text-black tw-font-semibold tw-text-base tw-ring-1 tw-ring-black/5`}>
                {getInitials(title)}
            </div>
            <div className="tw-text-xl tw-font-semibold tw-text-gray-900">{title}</div>
        </div>
    );

    if (!customer) {
        return (
            <div
                className="tw-bg-white tw-rounded tw-border tw-border-secondary tw-p-4 md:tw-p-6 tw-flex tw-flex-col tw-gap-4">
                <Header title={"Không có thông tin khách hàng"} avatarBg="tw-bg-amber-100" />
                <div className="tw-h-px tw-w-full tw-bg-secondary/60" />
                <div className="tw-text-gray-700 tw-bg-amber-50 tw-border tw-border-amber-200 tw-rounded-lg tw-p-3">
                    Đơn hàng này không có thông tin khách hàng. Hãy liên hệ quản trị viên để được hỗ trợ.
                </div>
            </div>
        );
    }

    return (
        <InfoBoxWrapper>
            <Header title={customer.name} avatarBg="tw-bg-blue-100" />
            <div className="tw-h-px tw-w-full tw-bg-secondary/60" />
            <Section
                title="Thông tin giao hàng"
                infoList={[{ title: "Địa chỉ giao hàng", value: deliveryAddress }]}
            />
            {SECTION_INFOs.map((sectionInfo: any, index: number) => (
                <Section
                    key={`section-${index}`}
                    title={sectionInfo.title}
                    infoList={infoListFactory(customer, sectionInfo.infoDefinitions)}
                />


            ))}
        </InfoBoxWrapper>
    );
};

export default CustomerInfo;
